import type { HubPayload } from '../types'

type Props = {
  hub: HubPayload
}

/** Banner de upgrade Start → Full. */
export function StartUpsellCard({ hub }: Props) {
  const plano = hub.plano
  if (!plano || plano.codigo !== 'start') {
    return null
  }

  const teto = plano.teto_cadastros ?? 2000
  const usados = plano.cadastros_usados ?? 0
  const pct = teto > 0 ? Math.min(100, Math.round((usados / teto) * 100)) : 0
  const nearCap = pct >= 70
  const expired = plano.valido === false

  return (
    <section className="bp-card" style={{ background: 'linear-gradient(135deg,#002776 0%,#003d99 100%)', color: '#fff' }}>
      <p className="bp-card__eyebrow" style={{ color: 'rgba(255,255,255,.75)' }}>
        {expired ? 'Plano expirado' : nearCap ? 'Rede crescendo' : 'EleitorWEB Start'}
      </p>
      <p style={{ margin: '0.25rem 0 0.75rem', fontWeight: 700 }}>
        {expired
          ? 'Renove ou faça upgrade para o plano completo com WhatsApp/IA e implantação.'
          : nearCap
            ? `Você já usou ${usados.toLocaleString('pt-BR')} de ${teto.toLocaleString('pt-BR')} cadastros. Upgrade libera teto e operação assistida.`
            : 'Quer WhatsApp com IA, domínio próprio e suporte de implantação? Conheça o plano Full.'}
      </p>
      <a
        className="bp-btn"
        style={{ background: '#009b3a', color: '#fff', border: 0 }}
        href={plano.upsell_url || 'https://eleitorweb.com.br/#contato'}
        target="_blank"
        rel="noreferrer"
      >
        Falar sobre upgrade
      </a>
      {!expired && teto > 0 ? (
        <p style={{ margin: '0.75rem 0 0', fontSize: '0.8rem', opacity: 0.85 }}>
          Uso da rede: {pct}% · validade {plano.validade || '12 meses'}
        </p>
      ) : null}
    </section>
  )
}
